"use client";

import type { UseRequestMutationProps } from "../../../request/hooks/useRequestMutation";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";
import { emailExistsSchema } from "./schema/emailExistsSchema";

export type UseRequestExistsEmailProps = UseRequestMutationProps;

export const useRequestExistsEmail = ({
  ...props
}: UseRequestExistsEmailProps = {}) => ({
  ...props,
  mutationPost: useRequestMutation({
    mutationFnRequestProps: (data: { email: string }) => ({
      body: JSON.stringify(data),
      method: "POST",
      requestType: "default",
      schema: emailExistsSchema,
      urlBackendPath: "/exists/email",
    }),
    onMutate: () => ({ noRefresh: true }),
  }),
});
